/* eslint-disable import/prefer-default-export */
import ct from 'countries-and-timezones';
import dayjs from '../../../utils/dayjs';

export const shortTimezones = [
  {
    name: 'Northern America',
    timezones: [
      'UTC -5 (EST / New York)',
      'UTC -8 (Pacific / Los Angeles)',
      'UTC -4 (AST / Halifax)',
      'UTC -7 (MST / Phoenix)',
    ],
  },
  {
    name: 'Southern  America',
    timezones: [
      'UTC -3 (BRT / Rio de Janeiro)',
      'UTC -5 (COT / Bogotá)',
      'UTC -4 (VET / Caracas)',
      'UTC -3 (ART / Buenos Aires)',
    ],
  },
  {
    name: 'Europe',
    timezones: [
      'UTC (GMT / London)',
      'UTC +1 (CET / Paris)',
      'UTC +3 (MSK / Moscow)',
      'UTC +2 (EET / Athens)',
    ],
  },
  {
    name: 'Asia',
    timezones: [
      'UTC +5.5 (IST / Mumbai)',
      'UTC +9 (JST / Tokyo)',
      'UTC +7 (ICT / Bangkok)',
      'UTC +8 (SGT / Singapore)',
    ],
  },
  {
    name: 'Africa',
    timezones: [
      'UTC +2 (CAT / Cairo)',
      'UTC +3 (EAT / Nairobi)',
      'UTC +1 (WAT / Lagos)',
      'UTC +0 (GMT / Accra)',
    ],
  },
  {
    name: 'Australia',
    timezones: [
      'UTC +8 (AWST / Perth)',
      'UTC +10 (AEST / Sydney)',
      'UTC +9.5 (ACST / Darwin)',
      'UTC +11 (AEDT / Melbourne)',
    ],
  },
  {
    name: 'Pacific',
    timezones: [
      'UTC +12 (NZST / Auckland)',
      'UTC -10 (HST / Honolulu)',
      'UTC +11 (NCT / Noumea)',
      'UTC +13 (TOT / Nukualofa)',
    ],
  },
];

export const NARegions = [
  {
    name: 'United States',
    abbreviation: 'US',
    states: [
      {
        name: 'Alabama',
        abbreviation: 'AL',
      },
      {
        name: 'Alaska',
        abbreviation: 'AK',
      },
      {
        name: 'American Samoa',
        abbreviation: 'AS',
      },
      {
        name: 'Arizona',
        abbreviation: 'AZ',
      },
      {
        name: 'Arkansas',
        abbreviation: 'AR',
      },
      {
        name: 'California',
        abbreviation: 'CA',
      },
      {
        name: 'Colorado',
        abbreviation: 'CO',
      },
      {
        name: 'Connecticut',
        abbreviation: 'CT',
      },
      {
        name: 'Delaware',
        abbreviation: 'DE',
      },
      {
        name: 'District Of Columbia',
        abbreviation: 'DC',
      },
      {
        name: 'Federated States Of Micronesia',
        abbreviation: 'FM',
      },
      {
        name: 'Florida',
        abbreviation: 'FL',
      },
      {
        name: 'Georgia',
        abbreviation: 'GA',
      },
      {
        name: 'Guam',
        abbreviation: 'GU',
      },
      {
        name: 'Hawaii',
        abbreviation: 'HI',
      },
      {
        name: 'Idaho',
        abbreviation: 'ID',
      },
      {
        name: 'Illinois',
        abbreviation: 'IL',
      },
      {
        name: 'Indiana',
        abbreviation: 'IN',
      },
      {
        name: 'Iowa',
        abbreviation: 'IA',
      },
      {
        name: 'Kansas',
        abbreviation: 'KS',
      },
      {
        name: 'Kentucky',
        abbreviation: 'KY',
      },
      {
        name: 'Louisiana',
        abbreviation: 'LA',
      },
      {
        name: 'Maine',
        abbreviation: 'ME',
      },
      {
        name: 'Marshall Islands',
        abbreviation: 'MH',
      },
      {
        name: 'Maryland',
        abbreviation: 'MD',
      },
      {
        name: 'Massachusetts',
        abbreviation: 'MA',
      },
      {
        name: 'Michigan',
        abbreviation: 'MI',
      },
      {
        name: 'Minnesota',
        abbreviation: 'MN',
      },
      {
        name: 'Mississippi',
        abbreviation: 'MS',
      },
      {
        name: 'Missouri',
        abbreviation: 'MO',
      },
      {
        name: 'Montana',
        abbreviation: 'MT',
      },
      {
        name: 'Nebraska',
        abbreviation: 'NE',
      },
      {
        name: 'Nevada',
        abbreviation: 'NV',
      },
      {
        name: 'New Hampshire',
        abbreviation: 'NH',
      },
      {
        name: 'New Jersey',
        abbreviation: 'NJ',
      },
      {
        name: 'New Mexico',
        abbreviation: 'NM',
      },
      {
        name: 'New York',
        abbreviation: 'NY',
      },
      {
        name: 'North Carolina',
        abbreviation: 'NC',
      },
      {
        name: 'North Dakota',
        abbreviation: 'ND',
      },
      {
        name: 'Northern Mariana Islands',
        abbreviation: 'MP',
      },
      {
        name: 'Ohio',
        abbreviation: 'OH',
      },
      {
        name: 'Oklahoma',
        abbreviation: 'OK',
      },
      {
        name: 'Oregon',
        abbreviation: 'OR',
      },
      {
        name: 'Palau',
        abbreviation: 'PW',
      },
      {
        name: 'Pennsylvania',
        abbreviation: 'PA',
      },
      {
        name: 'Puerto Rico',
        abbreviation: 'PR',
      },
      {
        name: 'Rhode Island',
        abbreviation: 'RI',
      },
      {
        name: 'South Carolina',
        abbreviation: 'SC',
      },
      {
        name: 'South Dakota',
        abbreviation: 'SD',
      },
      {
        name: 'Tennessee',
        abbreviation: 'TN',
      },
      {
        name: 'Texas',
        abbreviation: 'TX',
      },
      {
        name: 'Utah',
        abbreviation: 'UT',
      },
      {
        name: 'Vermont',
        abbreviation: 'VT',
      },
      {
        name: 'Virgin Islands',
        abbreviation: 'VI',
      },
      {
        name: 'Virginia',
        abbreviation: 'VA',
      },
      {
        name: 'Washington',
        abbreviation: 'WA',
      },
      {
        name: 'West Virginia',
        abbreviation: 'WV',
      },
      {
        name: 'Wisconsin',
        abbreviation: 'WI',
      },
      {
        name: 'Wyoming',
        abbreviation: 'WY',
      },
    ],
  },
  {
    name: 'Canada',
    abbreviation: 'CA',
    states: [
      {
        name: 'Alberta',
        abbreviation: 'AB',
      },
      {
        name: 'British Columbia',
        abbreviation: 'BC',
      },
      {
        name: 'Manitoba',
        abbreviation: 'MB',
      },
      {
        name: 'New Brunswick',
        abbreviation: 'NB',
      },
      {
        name: 'Newfoundland and Labrador',
        abbreviation: 'NL',
      },
      {
        name: 'Northwest Territories',
        abbreviation: 'NT',
      },
      {
        name: 'Nova Scotia',
        abbreviation: 'NS',
      },
      {
        name: 'Nunavut',
        abbreviation: 'NU',
      },
      {
        name: 'Ontario',
        abbreviation: 'ON',
      },
      {
        name: 'Prince Edward Island',
        abbreviation: 'PE',
      },
      {
        name: 'Quebec',
        abbreviation: 'QC',
      },
      {
        name: 'Saskatchewan',
        abbreviation: 'SK',
      },
      {
        name: 'Yukon Territory',
        abbreviation: 'YT',
      },
    ],
  },
];

// ISO alpha-2 country codes that have a region (state/province) dropdown.
export const REGION_COUNTRIES = NARegions.map((country) => country.abbreviation);

// Country codes pinned to the top of the "Select Country" dropdown (in this order).
export const PINNED_COUNTRIES = ['US', 'CA'];

// Country options for the "Select Country" dropdown. Label is "US - United States of
// America" (the package only exposes the ISO alpha-2 code, not a 3-letter abbreviation).
// Pinned countries come first (in PINNED_COUNTRIES order), the rest alphabetical by name.
export function getCountryOptions() {
  const countries = Object.values(ct.getAllCountries());
  const toOption = (country) => ({
    label: `${country.id} - ${country.name}`,
    value: country.id,
  });
  const pinned = PINNED_COUNTRIES.map((code) =>
    countries.find((country) => country.id === code)
  ).filter(Boolean);
  const rest = countries
    .filter((country) => !PINNED_COUNTRIES.includes(country.id))
    .sort((a, b) => a.name.localeCompare(b.name));
  return [...pinned, ...rest].map(toOption);
}

// Region (state/province) -> IANA timezone(s), keyed by country code then by the state
// `name` used in NARegions. Multi-zone states/provinces list every distinct offset. The
// `countries-and-timezones` package only maps at country granularity (and omits several US
// territories), so these are maintained by hand from canonical IANA zone names.
export const REGION_TIMEZONES = {
  US: {
    Alabama: ['America/Chicago'],
    Alaska: ['America/Anchorage', 'America/Adak'],
    'American Samoa': ['Pacific/Pago_Pago'],
    Arizona: ['America/Phoenix'],
    Arkansas: ['America/Chicago'],
    California: ['America/Los_Angeles'],
    Colorado: ['America/Denver'],
    Connecticut: ['America/New_York'],
    Delaware: ['America/New_York'],
    'District Of Columbia': ['America/New_York'],
    'Federated States Of Micronesia': ['Pacific/Chuuk', 'Pacific/Pohnpei', 'Pacific/Kosrae'],
    Florida: ['America/New_York', 'America/Chicago'],
    Georgia: ['America/New_York'],
    Guam: ['Pacific/Guam'],
    Hawaii: ['Pacific/Honolulu'],
    Idaho: ['America/Boise', 'America/Los_Angeles'],
    Illinois: ['America/Chicago'],
    Indiana: ['America/Indiana/Indianapolis', 'America/Chicago'],
    Iowa: ['America/Chicago'],
    Kansas: ['America/Chicago', 'America/Denver'],
    Kentucky: ['America/Kentucky/Louisville', 'America/Chicago'],
    Louisiana: ['America/Chicago'],
    Maine: ['America/New_York'],
    'Marshall Islands': ['Pacific/Majuro', 'Pacific/Kwajalein'],
    Maryland: ['America/New_York'],
    Massachusetts: ['America/New_York'],
    Michigan: ['America/Detroit', 'America/Menominee'],
    Minnesota: ['America/Chicago'],
    Mississippi: ['America/Chicago'],
    Missouri: ['America/Chicago'],
    Montana: ['America/Denver'],
    Nebraska: ['America/Chicago', 'America/Denver'],
    Nevada: ['America/Los_Angeles'],
    'New Hampshire': ['America/New_York'],
    'New Jersey': ['America/New_York'],
    'New Mexico': ['America/Denver'],
    'New York': ['America/New_York'],
    'North Carolina': ['America/New_York'],
    'North Dakota': ['America/Chicago', 'America/Denver'],
    'Northern Mariana Islands': ['Pacific/Saipan'],
    Ohio: ['America/New_York'],
    Oklahoma: ['America/Chicago'],
    Oregon: ['America/Los_Angeles', 'America/Boise'],
    Palau: ['Pacific/Palau'],
    Pennsylvania: ['America/New_York'],
    'Puerto Rico': ['America/Puerto_Rico'],
    'Rhode Island': ['America/New_York'],
    'South Carolina': ['America/New_York'],
    'South Dakota': ['America/Chicago', 'America/Denver'],
    Tennessee: ['America/Chicago', 'America/New_York'],
    Texas: ['America/Chicago', 'America/Denver'],
    Utah: ['America/Denver'],
    Vermont: ['America/New_York'],
    'Virgin Islands': ['America/Puerto_Rico'],
    Virginia: ['America/New_York'],
    Washington: ['America/Los_Angeles'],
    'West Virginia': ['America/New_York'],
    Wisconsin: ['America/Chicago'],
    Wyoming: ['America/Denver'],
  },
  CA: {
    Alberta: ['America/Edmonton'],
    'British Columbia': ['America/Vancouver', 'America/Fort_Nelson'],
    Manitoba: ['America/Winnipeg'],
    'New Brunswick': ['America/Moncton'],
    'Newfoundland and Labrador': ['America/St_Johns', 'America/Goose_Bay'],
    'Northwest Territories': ['America/Edmonton'],
    'Nova Scotia': ['America/Halifax'],
    Nunavut: ['America/Iqaluit', 'America/Rankin_Inlet', 'America/Cambridge_Bay'],
    Ontario: ['America/Toronto', 'America/Winnipeg'],
    'Prince Edward Island': ['America/Halifax'],
    Quebec: ['America/Toronto'],
    Saskatchewan: ['America/Regina'],
    'Yukon Territory': ['America/Whitehorse', 'America/Dawson'],
  },
};

// Build a timezone dropdown option from an IANA zone name. Label shows the live UTC offset
// via dayjs; value stays the raw IANA name. `fallbackOffset` is the library's static offset,
// used when dayjs can't resolve the zone (region-mapped zones have no library entry).
function toTimezoneOption(zoneName, fallbackOffset = '') {
  let offset = fallbackOffset;
  try {
    offset = dayjs()
      .tz(zoneName)
      .format('Z');
  } catch (e) {
    // dayjs couldn't resolve the zone — fall back to the static offset
  }
  // Display name without underscores (e.g. "America/Los Angeles"); value stays IANA.
  const displayName = zoneName.replace(/_/g, ' ');
  return { label: `${displayName} (UTC${offset})`, value: zoneName };
}

// Timezone options (IANA) for a country, optionally narrowed to a region (state/province).
// When a region with a known mapping is passed, only that region's zone(s) are returned;
// otherwise every zone in the country is returned. Label shows the live UTC offset via dayjs.
export function getTimezoneOptions(countryCode, regionName) {
  if (!countryCode) {
    return [];
  }
  const regionZones = regionName && REGION_TIMEZONES[countryCode]?.[regionName];
  if (regionZones && regionZones.length) {
    return regionZones
      .map((name) => toTimezoneOption(name))
      .sort((a, b) => a.value.localeCompare(b.value));
  }
  const zones = ct.getTimezonesForCountry(countryCode) || [];
  return zones
    .map((zone) => toTimezoneOption(zone.name, zone.utcOffsetStr))
    .sort((a, b) => a.value.localeCompare(b.value));
}

// Region (state/province) options for a country. Empty unless the country has NARegions data.
export function getRegionOptions(countryCode) {
  const country = NARegions.find((c) => c.abbreviation === countryCode);
  if (!country) {
    return [];
  }
  return country.states.map((state) => ({ label: state.name, value: state.name }));
}

// Compose the BE `region` value: "US-California", or just the country code when no region.
export function buildRegionPayload(countryCode, stateName) {
  if (!countryCode) {
    return '';
  }
  return stateName ? `${countryCode}-${stateName}` : countryCode;
}

// Split a stored BE `region` value back into { country, region }. Tolerant of a
// country-only value ("FR") and the legacy composite ("US-California").
export function parseRegionPayload(composite) {
  if (!composite) {
    return { country: '', region: '' };
  }
  const idx = composite.indexOf('-');
  if (idx === -1) {
    return { country: composite, region: '' };
  }
  return { country: composite.slice(0, idx), region: composite.slice(idx + 1) };
}
